import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpMainService } from "../http-main.service";
import {RewardsResponseModel} from "@itb-monorepo/models";



@Injectable()
export class CampaignsService {
  baseUrl = '/announcement/';
  private _HttpMainService = inject(HttpMainService);


  getRewards(): Observable<RewardsResponseModel> {
    return this._HttpMainService.get(`/report/v1/users/current/campaigns/current/rewards`);
  }
}
